import { Form, Input } from 'antd';
import { ReactElement } from 'react';
import styled from 'styled-components';

import { TransferDestination } from '../../../generated-api';

export const DetailRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(80px, 1fr)) 70px 8rem minmax(80px, 1fr);
  grid-gap: 8px;
  align-items: baseline;
`;
const RowHeaderLabel = styled.div`
  font-weight: bold;
  padding-left: 4px;
`;

export function TransferDestinationHeader(): ReactElement {
  return (
    <DetailRow>
      <RowHeaderLabel>金融機関名</RowHeaderLabel>
      <RowHeaderLabel>支店名</RowHeaderLabel>
      <RowHeaderLabel>口座種別</RowHeaderLabel>
      <RowHeaderLabel>口座番号･記号番号(ゆうちょ)</RowHeaderLabel>
      <RowHeaderLabel>口座名義</RowHeaderLabel>
    </DetailRow>
  );
}

type Props = {
  transferDestination: TransferDestination;
};

function TransferDestinationRow({ transferDestination }: Props): ReactElement {
  return (
    <>
      <DetailRow>
        <Form.Item>
          <Input disabled defaultValue={transferDestination.bank_name} />
        </Form.Item>
        <Form.Item>
          <Input disabled defaultValue={transferDestination.branch_name} />
        </Form.Item>
        <Form.Item>
          <Input disabled defaultValue={transferDestination.account_type} />
        </Form.Item>
        <Form.Item>
          <Input disabled defaultValue={transferDestination.account_number} />
        </Form.Item>
        <Form.Item>
          <Input disabled defaultValue={transferDestination.account_holder} />
        </Form.Item>
      </DetailRow>
    </>
  );
}

export default TransferDestinationRow;
